import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { acceptAllFlexMatchRequest } from 'RestAPIs/flex-match';

export type AcceptAllFlexMatchRequestPayload = {
  body: {
    taskIds: string[];
  };
};

const useAcceptAllFlexMatchRequest = ({ isWebSocketUpdate = false }) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: AcceptAllFlexMatchRequestPayload) =>
      acceptAllFlexMatchRequest(payload),
    {
      onSuccess: () => {
        !isWebSocketUpdate && queryClient.invalidateQueries('flexMatchTasks');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAcceptAllFlexMatchRequest;
